import type { UserMembership } from "@lumika/shared";

const SETUP_ROLES = new Set([
  "dealership_owner",
  "dealership_admin",
  "sales_manager",
  "service_manager",
]);

const USER_MANAGEMENT_ROLES = new Set(["dealership_owner", "dealership_admin"]);

export function canManageSetup(memberships: UserMembership[]): boolean {
  return memberships.some((membership) => {
    if (SETUP_ROLES.has(membership.role)) return true;
    // The shared contract allows permissions to be null — mirror the
    // backend's `?? {}` defense instead of crashing the shell render.
    const perms = (membership.permissions ?? {}) as Record<string, unknown>;
    return Boolean(perms.manageSetup || perms.manageChannels || perms.manageInventory);
  });
}

export function canManageUsers(memberships: UserMembership[]): boolean {
  return memberships.some((membership) => {
    if (USER_MANAGEMENT_ROLES.has(membership.role)) return true;
    const perms = (membership.permissions ?? {}) as Record<string, unknown>;
    return Boolean(perms.manageUsers);
  });
}
